@let data = correlation();
@let minimizedView = isMinimizedView();
@let loggerFirst = logger1();
@let distanceLFirst = distanceL1();
@let loggerSecond = logger2();
@let distanceLSecond = distanceL2();

@if (data) {
  @if (shortView()) {
    <div
    class="grid grid-cols-[minmax(0,max-content)_minmax(20px,_1fr)_minmax(0,max-content)] gap-y-[0.25rem] gap-x-[0.5rem] items-center text-[0.6875rem] sm:text-[0.625rem] font-[600] text-white"
    [ngClass]="{
      'text-[0.625rem]': minimizedView,
    }">
      <div class="mb-[0.375rem]" [ngClass]="{ '!mb-[2px]': minimizedView}" translate="@@shared-logger__with-double-dots"></div>

      <div class="mb-[0.375rem]" [ngClass]="{ '!mb-[2px]': minimizedView}"></div>

      <div class="mb-[0.375rem]" [ngClass]="{ '!mb-[2px]': minimizedView}" translate="@@shared-distance-to-leak__text"></div>

      <div class="truncate">{{loggerFirst}}</div>

      <div>
        <div class="relative w-full border-t border-dashed border-(--p-other-opacity-white-80) before:content-[''] before:absolute before:-top-[3px] before:w-0 before:h-0 before:-left-px before:border-y-[2.5px] before:border-y-transparent before:border-r-[5px] before:border-r-white/95 after:content-[''] after:absolute after:-top-[3px] after:w-0 after:h-0 after:-right-px after:border-y-[2.5px] after:border-y-transparent after:border-l-[5px] after:border-l-white/95">
        </div>
      </div>

      <div class="truncate">{{distanceLFirst}}</div>

      <div class="truncate">{{loggerSecond}}</div>

      <div>
        <div class="relative w-full border-t border-dashed border-(--p-other-opacity-white-80) before:content-[''] before:absolute before:-top-[3px] before:w-0 before:h-0 before:-left-px before:border-y-[2.5px] before:border-y-transparent before:border-r-[5px] before:border-r-white/95 after:content-[''] after:absolute after:-top-[3px] after:w-0 after:h-0 after:-right-px after:border-y-[2.5px] after:border-y-transparent after:border-l-[5px] after:border-l-white/95">
        </div>
      </div>

      <div class="truncate">{{distanceLSecond}}</div>
    </div>
  } @else {
    <div class="flex flex-col justify-center gap-2 text-white">
      <div class="grid grid-cols-[max-content_1fr_max-content_1fr_max-content] gap-x-2.5 px-10 items-center">
        <div class="flex flex-col items-center justify-center">
          <img
            src="imgs/logger.png"
            class="flex flex-col object-contain w-4 h-11"
            [ngClass]="{
              'h-[2.0625rem]': minimizedView
            }"
            [alt]="'@@shared-logger__serial-number' | translate:{I18N_VAR_SERIAL: loggerFirst}" />
        </div>

        <div class="flex flex-col items-center gap-1.5 min-w-0">
          <div class="text-[0.6875rem] font-semibold leading-none whitespace-nowrap">{{distanceLFirst}}</div>

          <div class="relative w-full border-t border-dashed border-(--p-other-opacity-white-80) before:content-[''] before:absolute before:-top-[3px] before:w-0 before:h-0 before:-left-px before:border-y-[2.5px] before:border-y-transparent before:border-r-[0.3125rem] before:border-r-white/95 after:content-[''] after:absolute after:-top-[0.1875rem] after:w-0 after:h-0 after:-right-px after:border-y-[2.5px] after:border-y-transparent after:border-l-[5px] after:border-l-white/95"></div>
        </div>

        <div class="flex flex-col items-center justify-center translate-y-px">
          <img
            src="imgs/pipe-2.png"
            class="block object-contain w-10 h-[2.375rem]"
            [ngClass]="{
              'h-[1.7813rem]': minimizedView
            }"
            [alt]="'@@shared-leak-pipe__text' | translate" />
        </div>

        <div class="flex flex-col items-center gap-1.5 min-w-0">
          <div class="text-[0.6875rem] font-semibold leading-none whitespace-nowrap">{{distanceLSecond}}</div>

          <div class="relative w-full border-t border-dashed border-(--p-other-opacity-white-80)  before:content-[''] before:absolute before:-top-[3px] before:w-0 before:h-0 before:-left-px before:border-y-[2.5px] before:border-y-transparent before:border-r-[0.3125rem] before:border-r-white/95 after:content-[''] after:absolute after:-top-[0.1875rem] after:w-0 after:h-0 after:-right-px after:border-y-[2.5px] after:border-y-transparent after:border-l-[5px] after:border-l-white/95"></div>
        </div>

        <div class="flex flex-col items-center justify-center">
          <img
            src="imgs/logger.png"
            class="block object-contain w-4 h-11"
            [ngClass]="{
              'h-[2.0625rem]': minimizedView
            }"
            [alt]="'@@shared-logger__serial-number' | translate:{I18N_VAR_SERIAL: loggerSecond}" />
        </div>
      </div>

      <div class="grid grid-cols-3 items-center">
        <div class="text-[0.625rem] leading-none whitespace-nowrap text-left" translate="@@shared-logger__serial-number" [translateParams]="{I18N_VAR_SERIAL: loggerFirst}"></div>

        <div class="text-[0.625rem] leading-none whitespace-nowrap text-center" translate="@@shared-leak__label"></div>

        <div class="text-[0.625rem] leading-none whitespace-nowrap text-right" translate="@@shared-logger__serial-number" [translateParams]="{I18N_VAR_SERIAL: loggerSecond}"></div>
      </div>
    </div>
  }
}
